import * as ActionsLayer from 'actions/layer'
import { isEmpty } from 'lodash'
import Timecode from 'smpte-timecode'
import { getFPSByRefVideo, secondsToTimelineTime } from '~/Util'
import * as Selectors from '~/selectors'
import Layer from '~/models/Layer'
import { createAssetFromSourceFile } from './createAssetFromSourceFile'
import { insertLayer } from './insertLayer'
import { selectInOutPointsTimeLineAssetID } from '~/selectors/preview'
import { setReferenceFileWithTimeCode, setSliderTimeCenter } from './timeline'
import { isOverlapAssets } from '~/Util/RangeTools'


export const addSourceFileByFrameTimeCode = selectedItems => async (dispatch, getState) => {
  if (!selectedItems || isEmpty(selectedItems)) return

  const targetLayerIndex = 0
  const state = getState()
  const sourceFiles = Selectors.getSourceFilesByIds(state, selectedItems)
  const targetLayer = Selectors.getLayers(state)[targetLayerIndex]
  const assetsByLayers = Selectors.getAssetsByLayers(state)
  const inOutPointsTimeLineAssetId = selectInOutPointsTimeLineAssetID(state)
  const inOutPointsTimeLineAsset = Selectors.selectAssetById(state, inOutPointsTimeLineAssetId)

  const files = []
  sourceFiles.forEach(file => {
    const fps = getFPSByRefVideo(file)
    const { frameCount } = new Timecode(file.startTimeCodeFrames || 0, fps, Boolean(file.dfFlag))
    const sec = frameCount / fps
    const timePosition = secondsToTimelineTime(sec, false)
    files.push({
      timePosition,
      file,
    })
  })
  files.sort((a, b) => a.timePosition - b.timePosition)

  const newAssets = []
  const newLayerIds = []
  let assetLayerId = targetLayer.id

  if (files.length === 1) {
    dispatch(setReferenceFileWithTimeCode(files[0].file))
  }

  const referenceVideo = Selectors.getReferenceVideoAsset(getState())

  files.forEach(({ file, timePosition }) => {
    const currentFile = (file.id === inOutPointsTimeLineAsset?.fileId && files.length === 1)
      ? inOutPointsTimeLineAsset
      : file
    const startTimeFile = timePosition
    const endTimeFile = timePosition + currentFile.duration
    const layerAssets = assetsByLayers.get(assetLayerId) ?? []

    // if the files have overlapping timecodes
    const isSelfIntersection = files.find(({ file, timePosition }) => {
      if (file.id === currentFile.id) {
        return false
      }
      return isOverlapAssets(startTimeFile, endTimeFile, timePosition, file.duration + timePosition)
    })

    // if files have intersections with assets on the timeline
    let isTimelineIntersection
    if (!isSelfIntersection) {
      isTimelineIntersection = layerAssets.find(asset => (
        isOverlapAssets(startTimeFile, endTimeFile, asset.startTime, asset.endTime)))
    }

    if (isSelfIntersection || (!isSelfIntersection && isTimelineIntersection)) {
      const newLayer = new Layer()
      dispatch(insertLayer({ index: targetLayerIndex, layer: newLayer, isAdditional: true }))
      assetLayerId = newLayer.id
      newLayerIds.push(newLayer.id)
    }

    const asset = createAssetFromSourceFile(currentFile, {
      layerId: assetLayerId,
      startTime: timePosition,
      videoSize: { width: referenceVideo.width, height: referenceVideo.height },
    })
    newAssets.push(asset)
  })

  dispatch(ActionsLayer.addAsset({ asset: newAssets, newLayerIds }))
  dispatch(setSliderTimeCenter(files[0].timePosition))
}
